import React, { useCallback } from 'react';
import Deals, { GetDealsExportResponseBody } from './Deals';
import { getApiHost } from 'src/utils/apiUtils';

const DealsContainer = ({}) => {
  const handleValidate = async (data: GetDealsExportResponseBody) => {
    window.open(`${getApiHost()}/api/csv/deal/${encodeURIComponent(getGraphQL(data))}`, '_blank');
  };

  const getGraphQL = useCallback((data: GetDealsExportResponseBody) => {
    let res = '';

    const reasonOfLooseIds =
      data.lossReasons && data.lossReasons.length > 0
        ? `reasonOfLooseIdsOperator: "Fait partie de", reasonOfLooseIds: ${JSON.stringify(data.lossReasons)},`
        : '';

    const creatorIds =
      data.creatorIds && data.creatorIds.length > 0
        ? `creatorIdsOperator: "Fait partie de", creatorIds: ${JSON.stringify(data.creatorIds)},`
        : '';

    const dealTypeIds =
      data.types && data.types.length > 0
        ? `dealTypeIdsOperator: "Fait partie de", dealTypeIds: ${JSON.stringify(data.types)},`
        : '';

    const employeeCommercialsSearch =
      data.employeeCommercials && data.employeeCommercials.length > 0
        ? `, commercialEmployeeIdsOperator: "Fait partie de", commercialEmployeeIds:${JSON.stringify(
            data.employeeCommercials
          )}`
        : '';

    const dateCreateStart = data.dateCreateStart ? `dateCreateStart: "${data.dateCreateStart}", ` : '';
    const dateCreateEnd = data.dateCreateEnd ? `dateCreateEnd: "${data.dateCreateEnd}", ` : '';

    const dateClosedStart = data.dateClosedStart ? `dateClosedStart: "${data.dateClosedStart}", ` : '';
    const dateClosedEnd = data.dateClosedEnd ? `dateClosedEnd: "${data.dateClosedEnd}", ` : '';

    const dateCreateOperator =
      data.dateCreateStart || data.dateCreateEnd
        ? `dateCreateOperator: "${
            data.dateCreateStart && !data.dateCreateEnd
              ? 'Après'
              : !data.dateCreateStart && data.dateCreateEnd
              ? 'Avant'
              : 'Entre'
          }", `
        : '';

    const dateClosedOperator =
      data.dateClosedStart || data.dateClosedEnd
        ? `dateClosedOperator: "${
            data.dateClosedStart && !data.dateClosedEnd
              ? 'Après'
              : !data.dateClosedStart && data.dateClosedEnd
              ? 'Avant'
              : 'Entre'
          }", `
        : '';

    const domainId = data.domainId ? `domainId: ${data.domainId}, ` : '';
    const stepNumber = data.stepNumber ? `stepNumber: "${data.stepNumber}", ` : '';
    const lost = data.lost !== undefined && data.lost !== null ? `lost: ${data.lost}, ` : '';
    const won = data.won !== undefined && data.won !== null ? `won: ${data.won}, ` : '';
    const standBy = data.standby !== undefined && data.standby !== null ? `standBy: ${data.standby}, ` : '';
    const customerIds =
      data.customerId !== undefined && data.customerId !== null
        ? `customerIdsOperator: "Fait partie de", customerIds: ${JSON.stringify([data.customerId])}, `
        : '';

    res =
      `{ deals(${reasonOfLooseIds}${dealTypeIds}${creatorIds}${domainId}${stepNumber}${dateCreateStart}${dateCreateEnd}${dateCreateOperator}${dateClosedStart}${dateClosedEnd}${dateClosedOperator}${lost}${won}${standBy}${customerIds}` +
      'orderBy:dateCreate, ASC:false, originIdsOperator: "Fait partie de", originIds:' +
      JSON.stringify(data.origins) +
      employeeCommercialsSearch +
      '){ items{ id, name, stepNumber, type{ id, name}, creator{ user{ id, username } }, dateCreate, desiredClotureDate, dateLastStep, customer{ id, installationSite{ socialReason } }, type { name }, ' +
      'stepCommercial{ proposition{ pdc } }, ' +
      'stepProd{ id, intermediateStageNumber, dealOrder{ salesAssistant{ user{ id, username } } }, preparation{ orderPicker{ user{ id, username } }, installation{ installer{ user{ id, username } } } } }' +
      ' } } }';

    return res;
  }, []);

  return <Deals onValidate={handleValidate} />;
};
export default DealsContainer;
